// src/components/common_components/bill_payments/Common_bill_payments.js
import { Link } from "react-router-dom";
import "./Common_bill_payments.css";

const Common_bill_payments = ({ img, title, baseLink }) => {
  return (
    <section className="common-payment-section">
      <Link to={baseLink}>
        <div className="service_card card">
          <div className="card-body">
            <div className="white_box">
              <img src={img} alt={title} className="service_icon" />
            </div>
          </div>
          <div className="card-footer">
            <h5 className="service_title">{title}</h5>
          </div>
        </div>
      </Link>
    </section>
  );
};

export default Common_bill_payments;
